/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {
    OutsourcedGameData,
    OutsourcedInitData,
    SymbolValues,
    WinData,
} from "./OutsourcedData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Outsourced} from "../Outsourced";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";

// first attempt at doing big symbols, probably not a very good one :joy:
export interface reelPosition {
    reelID:number,
    reelPosition:number
}
type reelPositionWithSymbol = reelPosition & {symbol:string};

export class OutsourcedModel extends GameModel<OutsourcedInitData, OutsourcedGameData> {

    public isRestore:boolean = false;
    public wasCrashGameRestore:boolean = false;
    //public visibleReelMatrix:StateMatrix<string>;
    //public evaluatedArea:StateMatrix<string>;
    //public winData:WinData;
    public wins:WinData[];
    public isRestoreFeatureBet:boolean;
    public buyFeatureName:string;
    public symbolValues?:SymbolValues;
    public totalWays:number;
    public ways:number;
    public xWaysSize:number;
    public totalWin:number;
    public winRatio:number;
    public fsWinRatio:number;
    public totalWinRatio:number;
    public previousCollectorValue:number;
    public currentCollectorValue:number;
    public isGodModeDeluxe:boolean;
    public isGodMode:boolean;
    public actualSymbolSizes:number[][];
    private parsedReels:reelPositionWithSymbol[];
    private parsedEvaluatedArea:reelPositionWithSymbol[];
    public shouldStartWithMultiplier:boolean
    public startMultiplier:number
    public firstXBetSpin:boolean = false;

    public hasWonFsClient:boolean = false;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        this.currentCollectorValue = 0;
        this.previousCollectorValue = 0;

        api.events.once("featureBet", (data:boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data:string) => {
            this.buyFeatureName = data;
        });
        Outsourced.apiPlugin.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < Outsourced.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Outsourced.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                } else if (this.data.nextMode == GameMode.NORMAL) {
                    this.buyFeatureName = "";
                }
            }
            this.firstXBetSpin = (Outsourced.reelView.getSymbolAt(1, 0).symbolName != "SC" && this.buyFeatureName == "BOOSTED_BET");
            if (betData.type != "zeroBet")
                this.wasCrashGameRestore = false;
        });

        Outsourced.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < Outsourced.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Outsourced.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                } else if (this.data.nextMode == GameMode.NORMAL) {
                    this.buyFeatureName = "";
                }
            }
            this.firstXBetSpin = (Outsourced.reelView.getSymbolAt(1, 0).symbolName != "SC" && this.buyFeatureName == "BOOSTED_BET");
            if (betData.type != "zeroBet")
                this.wasCrashGameRestore = false;
        });

        Outsourced.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => {
            const activeBetFeature = SlotKeypad.apiPlugIn.betFeatureController.getActiveBetFeature();
            if (activeBetFeature?.name == "BOOSTED_BET") {
                if ((this.isRestore && (!this.isFreespins() || this.data.upgradeBetCount > 0)) || !this.isRestore)
                    Outsourced.reelView.enableXBet()
            } else {
                Outsourced.reelView.disableXBet()
            }
        })


    }

    protected onInit(data:OutsourcedInitData):void {
        super.onInit(data);
        this.symbolValues = data.symbolValues;
        this.isRestore = data.isRestoreState;
        this.wasCrashGameRestore = data.isRestoreState && data.mode == "CRASH_GAME";
        this.isGodModeDeluxe = this.buyFeatureName == "CRASH_GAME" && this.data.wasFeatureBuy;
        this.isGodMode = this.buyFeatureName == "GOD_MODE" && this.data.wasFeatureBuy;
        this.fsWinRatio = Math.round(this.data.freespinsWinnings / this.initData.bet);
        this.totalWinRatio = Math.round(this.data.accumulatedRoundWin / this.initData.bet);
        this.calculateWays();
        this.calculateActualSymbolSizes();
    }

    public onGame(data:OutsourcedGameData):void {
        super.onGame(data);
        this.isRestore = false;
        this.setupReels();
        this.setupEvaluatedArea();
        this.createWinData();
        this.calculateWays();
        this.calculateActualSymbolSizes();
        this.totalWin = this.gameData.accumulatedRoundWin;
        this.winRatio = this.gameData.totalSpinWinnings / Outsourced.getBetPrice();
        this.fsWinRatio = Math.round(this.data.freespinsWinnings / this.gameData.playedBetValue);
        this.totalWinRatio = Math.round(this.data.accumulatedRoundWin / this.gameData.playedBetValue);
        this.totalWays = this.gameData.betWayWins
            .map((win) => win.numberOfCombinations)
            .reduce((a,b) => a+b, 0);
        this.xWaysSize = this.gameData.symbolSizes
            .reduce((a,b) => a.concat(b), [])
            .reduce((a,b) => Math.max(a,b), 1);
        this.isGodModeDeluxe = this.buyFeatureName == "CRASH_GAME" && this.data.wasFeatureBuy;
        this.isGodMode = this.buyFeatureName == "GOD_MODE" && this.data.wasFeatureBuy;
        this.shouldStartWithMultiplier = this.buyFeatureName?.startsWith("BOOSTED_BET_STATE") &&
                                         this.data.boostedBet &&
                                         this.data.mode == GameMode.NORMAL;
        if (this.shouldStartWithMultiplier)
            this.startMultiplier = parseInt(this.buyFeatureName[this.buyFeatureName.length - 1], 10);
    }

    public isBoostedBet():boolean {
        return this.data.boostedBet;
    }

    protected setupReels(): void {
        const overflowAdjustment = this.data.mode != GameMode.NORMAL ? 0 : 1;
        this.parsedReels =
            this.data.reels
                .map((reel, reelID) =>
                    reel.map((sym, reelPosition) => {
                        return {
                            symbol: sym,
                            reelID: reelID,
                            reelPosition: reelPosition - overflowAdjustment,
                        }
                    }))
                .reduce((a,b) => a.concat(b), []);
    }

    protected setupEvaluatedArea(): void {
        this.parsedEvaluatedArea =
            this.gameData.evaluatedArea
                .map((reel, reelID) =>
                    reel.map((sym, reelPosition) => {
                        return {
                            symbol: sym,
                            reelID: reelID,
                            reelPosition: reelPosition
                        }
                    }))
                .reduce((a,b) => a.concat(b), []);
    }


    private createWinData() {
        this.wins =  this.gameData.betWayWins.map((win) => {
            return {
                winLineData: win,
                winningPositions: this.parsedEvaluatedArea.filter((pos) => pos.reelID < win.length &&
                    (pos.symbol == win.symbol ||
                                   pos.symbol == "W" ||
                                   pos.symbol == "XN" ))
            }
        });
    }

    private calculateWays() {
        this.ways = this.data.symbolSizes.map((reel) => reel.reduce((a,b) => a + b, 0)).reduce((a,b) => a * b, 1);
    }

    private calculateActualSymbolSizes() {
        this.actualSymbolSizes = this.data.symbolSizes.map((reel, col) => {
            return reel.map((pos, row) => {
                return pos / this.data.splitSizes[col][row];
            })
        })
    }

    // win stuff
    public getWinningPositions(): reelPosition[] {
        if (this.isRestore) {
            return this.initData.winningSymbols.map((reel, reelIndex) => reel.map((sym, reelPosition) => {
                return {reelID: reelIndex, reelPosition: reelPosition, isWinning: sym == 1};
            })).reduce((a,b) => a.concat(b), [])
                .filter((sym) => sym.isWinning);
        } else {
            const positions = this.wins.map((win) => win.winningPositions).reduce((a,b) => a.concat(b), []);
            return Array.from(new Set([...positions]));
        }
    }

    public getNonWinningPositions(): reelPosition[] {
        return this.parsedEvaluatedArea.filter((pos) => this.getWinningPositions().indexOf(pos) == -1);
    }

    public isFreespins():boolean {
        return this.data.mode == GameMode.FREESPIN || this.data.mode == "FREESPIN_RESPIN";
    }

    hasStartingMultipliers():boolean {
        return this.buyFeatureName?.startsWith("BOOSTED_BET_STATE") && this.data.boostedBet;
    }

    startingMultiplier():number {
        return parseInt(this.buyFeatureName[this.buyFeatureName.length - 1], 10);
    }

    isSuperFreespins():boolean {
        return (this.data.freespinsPlayed + this.data.freespinsLeft) == 5;
    }

    specialWinThresholds():boolean {
        return this.data.wasFeatureBuy ||
            this.data.boostedBet &&
            this.buyFeatureName != "BOOSTED_BET" &&
            this.initData.featureBuyTimesBetValue.find((feature:{name:string}) => feature.name == this.buyFeatureName)!.price > 20;
            // max win och 5000 with 250x win as threshold for highest level, meaning we wont ever be able to reach it
            // if the bet is base bet x20 or higher in cost
    }

    shouldPlayExtraBet():boolean {
        return this.data.accumulatedRoundWin >= this.data.upgradeBetCost &&
               (this.data.nextPlayerInteraction != undefined
                ? this.data.nextPlayerInteraction.playUpgradeBet != undefined
                : true);
    }

    preXwaysWays():number {
        return this.data.splitSizes.map((reel) => reel.reduce((a,b) => a + b, 0)).reduce((a,b) => a * b, 1);
    }

    postXwaysWays():number {
        return this.data.symbolSizes.map((reel) => reel.reduce((a,b) => a + b, 0)).reduce((a,b) => a * b, 1);
    }
}